import {
  LOGIN_SUCCESS,
  REGISTER_FAILED,
  LOGOUT,
  RESET_PASSWORD_REQUEST,
  RESET_PASSWORD_FAILED,
  FORGET_PASSWORD_SUCCESS,
  CHECK_NDA_SUCCESS,
  CONTACT_US_REQUEST,
  CONTACT_US_FAILED,
  CHANGE_PASSWORD_SUCCESS,
  REQUEST_GITHUB_REQUEST,
  REQUEST_GITHUB_FAILED,
  UPDATE_USER_STATUS_SUCCESS,
  CREATE_USER_REQUEST,
  CREATE_USER_FAILED,
  CREATE_USER_SUCCESS,
  UPDATE_USER_STATUS_FAILED,
  UPDATE_USER_STATUS_REQUEST,
  REQUEST_GITHUB_SUCCESS,
  CHANGE_PASSWORD_FAILED,
  CHANGE_PASSWORD_REQUEST,
  CONTACT_US_SUCCESS,
  CHECK_NDA_FAILED,
  CHECK_NDA_REQUEST,
  FORGET_PASSWORD_FAILED,
  RESET_PASSWORD_SUCCESS,
  FORGET_PASSWORD_REQUEST,
  REGISTER_SUCCESS,
  REGISTER_REQUEST,
  LOGIN_FAILED,
  LOGIN_REQUEST,
  ADMIN_LOGIN_REQUEST,
} from "redux/constants";

const initialState = {
  loading: false,
  user_data: {},
  token: "",
  token_validity: "",
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADMIN_LOGIN_REQUEST:
    case LOGIN_REQUEST:
    case REGISTER_REQUEST:
    case FORGET_PASSWORD_REQUEST:
    case RESET_PASSWORD_REQUEST:
    case CHECK_NDA_REQUEST:
    case CREATE_USER_REQUEST:
    case CONTACT_US_REQUEST:
    case CHANGE_PASSWORD_REQUEST:
    case REQUEST_GITHUB_REQUEST:
    case UPDATE_USER_STATUS_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case LOGIN_SUCCESS:
      return {
        ...state,
        loading: false,
        user_data: action.payload.user_data,
        token: action.payload.token,
        token_validity: action.payload.token_validity,
      };

    case LOGIN_FAILED:
    case LOGOUT:
    case REGISTER_FAILED:
      return {
        ...state,
        loading: false,
        user_data: {},
        token: "",
        token_validity: "",
      };

    case REGISTER_SUCCESS:
    case FORGET_PASSWORD_SUCCESS:
    case RESET_PASSWORD_SUCCESS:
    case CHECK_NDA_SUCCESS:
    case CREATE_USER_SUCCESS:
    case CONTACT_US_SUCCESS:
    case CHANGE_PASSWORD_SUCCESS:
    case REQUEST_GITHUB_SUCCESS:
    case UPDATE_USER_STATUS_SUCCESS:
    case FORGET_PASSWORD_FAILED:
    case RESET_PASSWORD_FAILED:
    case UPDATE_USER_STATUS_FAILED:
    case REQUEST_GITHUB_FAILED:
    case CHANGE_PASSWORD_FAILED:
    case CONTACT_US_FAILED:
    case CREATE_USER_FAILED:
    case CHECK_NDA_FAILED:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
}
